<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-select v-model="form.rptType" :items="reportTypeList" :label="labels.rptType" item-text="label" item-value="value" />
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <cal-picker v-model="form.fromDate" :label="labels.fromDate" v-validate="'required'" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12>
          <v-checkbox
            dense
            v-model="form.rptParam"
            :label="labels.rptParam"
            :error-messages="errors.collect('rptParam')"
            data-vv-name="rptParam"
            :data-vv-as="labels.rptParam"
            hide-details
            ></v-checkbox>
        </v-flex>
        <v-flex xs6 class="mt-3">
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import clone from 'clone'
export default {
  mixins: [
    MessageMixin
  ],
  data() {
    return {
      menu: {},
      submitting: false,
      form: {
        rptType: 'ackDate',
        fromDate: '',
        rptParam: true,
        format: 'PDF'
      },
      labels: {
        fromDate: 'Claims Entry Date From*',
        rptType: 'Report Type',
        rptParam: 'Print Runtime Parameters',
        export: 'EXPORT TO'
      },
      reportTypeList: [
        { label: 'Claims With Late/No Acknowledgement Date', value: 'ackDate' },
        { label: 'Claims With Late Request Date', value: 'reqDate' }
      ],
      supportedFormat: ['PDF', 'XLSX'],
      panel1: [0]
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.custom1Reports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.custom1Reports.init !== 1) {
          await this.$store.dispatch('custom1ReportsInit')
        }
        const apiURI = this.rptMenu.claimWithLate
        const result = await this.$http.get(apiURI)
        if (result.data) {
          this.menu = extractMenu(result.data._links)
          // this.getPolTypeList()
        }
      } catch (err) {
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let clonedForm = clone(this.form)
          await this.$http.post(apiURI, clonedForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  }
}
</script>
